import { gql } from "apollo-boost";

const DISCONNECT_DMS_SHOP = gql`
  mutation disconnectDmsShop {
    disconnectDmsShop {
      data
      status
      error
    }
  }
`;

export default DISCONNECT_DMS_SHOP;
